import { executeRequest, JFSRequest } from '@jfs/network'
import { RootStore } from '../data/store'
import { formatDate, isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'
import { findRiskSettingValue } from './getGlobalEntityQueue'

export const responseParser = (response: any, ddData) => {
  console.log('response=', response)
  const data = isSuccessResponse(response)
  console.log('response data =', data)

  return {
    data:
      data?.processInstances?.map((interaction) => ({
        createAt: formatDate(interaction?.time),
        requestId: interaction?.requestId,
        makerUserName: interaction?.riskMakerUser?.username,
        checkerUserName: interaction?.riskCheckerOneUser?.username,
        actionType: interaction?.actionType,
        actionDownload: 'Download',
        ...interaction,
        commentsDetails:
          getCommentDetails(interaction?.merchant?.riskSettings, interaction?.changes, ddData) + interaction?.comments,
      })) ?? [],
    pagination: {
      size: data?.pageSize,
      totalElements: data?.totalItems ?? 0,
      number: data?.pageNumber + 1,
      totalPages: Math.ceil(data?.totalItems / data?.pageSize),
    },
  }
}

export const fetchInteractionHistoryApi = (req: any, ddData: any, abortController?: any) => {
  if (!req?.merchantId || req?.merchantId?.length === 0) {
    return new Promise((resolve) => resolve({ data: [] }))
  }
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.interactionHistoryApi),
    method: 'POST',
    cache: false,
    config: sitConfig(RootStore.session.getTokens, abortController),
    headers: getHeaders(),
    body: req,
  }

  return executeRequest(request)
    .then((resp) => responseParser(resp, ddData))
    .catch((error) => {
      throw error
    })
}

const getCommentDetails = (riskSettings, changes, ddData) => {
  const configMap = changes?.riskSettings?.configMap?.map((configs, index) => ({
    ...riskSettings.configMap[index],
    value: configs?.value,
  }))
  const limits = changes?.riskSettings?.limits?.map((limit, index) => ({
    ...riskSettings.limits[index],
    value: limit?.value,
  }))

  const commentDetailsFields = [
    { data: configMap, configType: 'RISK_SETTING', text: 'Merchant Risk', key: 'MERCHANT_RISK' },
    {
      data: configMap,
      configType: 'RISK_SETTING',
      text: 'Allow ParentId Settlement',
      key: 'ALLOW_PARENT_ID_SETTL_FLAG',
    },
    { data: configMap, configType: 'RISK_SETTING', text: 'Delivery Period', key: 'DELIVERY_PERIOD' },
    {
      data: configMap,
      configType: 'RISK_SETTING',
      text: 'Defferred Delivery Options',
      key: 'MERCHANT_DAY_DELIVERY',
      ddKey: 'DeferredDeliveryOptions',
    },
    { data: configMap, configType: 'RISK_SETTING', text: 'International Acceptance', key: 'INTERNATIONAL_ACCEPTANCE' },
    {
      data: limits,
      configType: 'OPEN_LOOP_RISK',
      text: 'Current Transaction Limit(Rs.)',
      key: 'OPEN_LOOP_CURRENT_TRANSACTION_LIMIT',
      ddKey: 'NA',
    },
    {
      data: limits,
      configType: 'OPEN_LOOP_RISK',
      text: 'Updated Exit Limit (Rs.)',
      key: 'OPEN_LOOP_CURRENT_EXIT_LIMIT',
      ddKey: 'NA',
    },
    {
      data: limits,
      configType: 'OPEN_LOOP_RISK',
      text: 'Updated Current Transaction count',
      key: 'OPEN_LOOP_CURRENT_TRANSACTION_COUNT',
      ddKey: 'NA',
    },
  ]

  console.log('htagddd configMap=', configMap)
  console.log('htagddd limit=', limits)
  console.log('htagddd findRiskSettingValue(c', findRiskSettingValue(configMap, 'RISK_SETTING', 'MERCHANT_RISK'))
  return commentDetailsFields
    .map((item) => {
      const changedObject = findRiskSettingValue(item?.data, item?.configType, item?.key)?.at(-1)
      const newValue =
        extraFieldsDesc[changedObject?.newValue] ??
        ddData?.find(
          (ddItem) => ddItem?.value === changedObject?.newValue && (!item?.ddKey || item?.ddKey === ddItem?.key),
        )?.description ??
        changedObject?.newValue

      const oldValue =
        extraFieldsDesc[changedObject?.oldValue] ??
        ddData?.find(
          (ddItem) => ddItem?.value === changedObject?.oldValue && (!item?.ddKey || item?.ddKey === ddItem?.key),
        )?.description ??
        changedObject?.oldValue
      if (changedObject?.oldValue && changedObject?.newValue) {
        return `${item?.text} changed from ${oldValue} to  ${newValue} \n\n`
      } else if (changedObject?.newValue) {
        return `${item?.text} updated to  ${newValue} \n\n`
      }
      return ''
    })
    .filter((item) => item?.length > 0)
    .join('')
}

const extraFieldsDesc = {
  Y: 'yes',
  N: 'No',
}
